"use strict";

exports.__esModule = true;
exports.PlantTwinScreenWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _reactSortableTree = require("react-sortable-tree");
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Toolbar = require("../../Core/Toolbar");
var _Translator = require("../../Core/Translator");
var _PlantTwinTreeView = require("../PlantTwinTreeView");
var _SearchInput = require("../../Core/SearchInput");
var _RestAPI = require("../../API/RestAPI");
var _DeviceListScreenPlantTwin = require("../../Device/DeviceListScreenPlantTwin");
var _System = require("../../../System");
var _ToolbarDescription = require("../../Core/ToolbarDescription");
var _DeviceListContext = require("../../Device/DeviceListContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var StyledToolbar = (0, _styledComponents["default"])(_Toolbar.Toolbar).withConfig({
  displayName: "PlantTwinScreenWrapper__StyledToolbar",
  componentId: "sc-14lz6n-0"
})(["height:", ";grid-area:toolbar;"], function (props) {
  return props.theme.ToolbarHeight;
});
var GridWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PlantTwinScreenWrapper__GridWrapper",
  componentId: "sc-14lz6n-1"
})(["display:grid;grid-template-columns:20% 20% 20% 40%;grid-template-areas:", ";"], function (props) {
  return props.gridTemplateAreas;
});
var TreeViewWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PlantTwinScreenWrapper__TreeViewWrapper",
  componentId: "sc-14lz6n-2"
})(["height:", ";grid-area:treeView;"], function (props) {
  return "calc(100vh - " + props.theme.ToolbarHeight + " - " + props.theme.NavbarHeight + ")";
});
var DeviceViewWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PlantTwinScreenWrapper__DeviceViewWrapper",
  componentId: "sc-14lz6n-3"
})(["grid-area:editor;height:", ";border-left:solid 1px black;"], function (props) {
  return "calc(100vh - " + props.theme.ToolbarHeight + " - " + props.theme.NavbarHeight + ")";
});
var ButtonWrapper = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "PlantTwinScreenWrapper__ButtonWrapper",
  componentId: "sc-14lz6n-4"
})(["&:nth-child(1){margin-right:2%;}&:nth-child(2){margin-right:2%;}"]);
var SearchbarWrapper = (0, _styledComponents["default"])(_SearchInput.DebouncedSearchInput).withConfig({
  displayName: "PlantTwinScreenWrapper__SearchbarWrapper",
  componentId: "sc-14lz6n-5"
})(["&:nth-child(1){margin-right:2%;}"]);
var updateHierarchy = function updateHierarchy(api, tree) {
  var flatData = (0, _reactSortableTree.getFlatDataFromTree)({
    treeData: tree,
    getNodeKey: function getNodeKey(e) {
      return e.uuid;
    },
    ignoreCollapsed: false
  }).map(function (_ref) {
    var node = _ref.node;
    var uuid = node.uuid,
      path = node.path;
    return {
      uuid: uuid,
      path: path
    };
  });
  var hierarchy = {
    devices: flatData
  };
  return api.post("/api/v1/plant/hierarchy", hierarchy);
};
var PlantTwinScreenWrapper = exports.PlantTwinScreenWrapper = (0, _reactRouterCompat.withRouter)(function (props) {
  var devices = _react["default"].useContext(_DeviceListContext.AllDeviceListContext);
  var api = _react["default"].useContext(_RestAPI.RestAPIContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var _useState = (0, _react.useState)([]),
    treeData = _useState[0],
    setTreeData = _useState[1]; // store device hierarchy in tree model.
  var _useState2 = (0, _react.useState)(devices.length),
    numDevicesMatched = _useState2[0],
    setNumDevicesMatched = _useState2[1];
  var _useState3 = (0, _react.useState)("view"),
    mode = _useState3[0],
    setMode = _useState3[1];
  var _useState4 = (0, _react.useState)(""),
    searchString = _useState4[0],
    setSearchString = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    searchFocusIndex = _useState5[0],
    _ = _useState5[1];
  var handleCreate = function handleCreate() {
    var history = props.history;
    history.push((0, _System.getScreenPath)("CreateDevicePlantTwin"));
  };
  return /*#__PURE__*/_react["default"].createElement(GridWrapper, {
    gridTemplateAreas: mode === "view" ? "\"toolbar toolbar toolbar toolbar\" \"treeView treeView treeView editor\"" : "\"toolbar toolbar toolbar toolbar\" \"treeView treeView treeView treeView\""
  }, /*#__PURE__*/_react["default"].createElement(StyledToolbar, null, /*#__PURE__*/_react["default"].createElement(_Toolbar.LeftToolbarContent, null, /*#__PURE__*/_react["default"].createElement(SearchbarWrapper, {
    "data-testid": "PlantTwinScreenWrapper.searchBox",
    debounceDuration: 5
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: true,
    placeholder: translate("DataTableFilters.search", "Search"),
    type: "search",
    value: searchString,
    onChange: function onChange(value) {
      return setSearchString(value);
    },
    onReset: function onReset() {
      return setSearchString("");
    },
    style: {
      borderRadius: "3px"
    }
  }), /*#__PURE__*/_react["default"].createElement(ButtonWrapper, {
    "data-testid": "PlantTwinScreenWrapper.expandAll",
    icon: _icons.IconNames.EXPAND_ALL,
    onClick: function onClick() {
      setTreeData((0, _reactSortableTree.toggleExpandedForAll)({
        treeData: treeData,
        expanded: true
      }));
    }
  }, translate("PlantTwinScreenWrapper.ExpandButton.text", "Expand All")), mode === "view" ? /*#__PURE__*/_react["default"].createElement(ButtonWrapper, {
    "data-testid": "PlantTwinScreenWrapper.editTwinButton",
    icon: _icons.IconNames.EDIT,
    onClick: function onClick() {
      return setMode("edit");
    }
  }, translate("PlantTwinScreenWrapper.EditButton.text", "Edit Twin")) : null), /*#__PURE__*/_react["default"].createElement(_Toolbar.RightToolbarContent, null, mode === "view" ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ToolbarDescription.ToolbarDescription, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DevicesToolbar.count",
    defaultMessage: "\n                    {value} {count, plural,\n                      one {device}\n                      other {devices}\n                    }\n                  ",
    values: {
      value: /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
        value: numDevicesMatched
      })),
      count: numDevicesMatched
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    type: "button",
    icon: _icons.IconNames.ADD,
    onClick: function onClick() {
      return handleCreate();
    },
    "data-testid": "PlantTwinScreen.CreateDeviceButton"
  }, translate("PlantTwinScreenWrapper.createButton.text", "Create Device"))) : null, mode === "edit" ? /*#__PURE__*/_react["default"].createElement(ButtonWrapper, {
    "data-testid": "PlantTwinScreenWrapper.saveButton",
    icon: _icons.IconNames.FLOPPY_DISK,
    intent: _core.Intent.PRIMARY,
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return updateHierarchy(api, treeData);
          case 1:
            setMode("view");
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))
  }, translate("PlantTwinScreenWrapper.saveButton.text", "Save")) : null, mode === "edit" ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "PlantTwinScreenWrapper.cancelButton",
    icon: _icons.IconNames.CROSS,
    onClick: function onClick() {
      return setMode("view");
    }
  }, translate("PlantTwinScreenWrapper.cancelButton.text", "Cancel")) : null)), /*#__PURE__*/_react["default"].createElement(TreeViewWrapper, {
    "data-testid": "PlantTwinScreenWrapper.PlantTwinTreeView"
  }, /*#__PURE__*/_react["default"].createElement(_PlantTwinTreeView.PlantTwinTreeView, {
    treeData: treeData,
    setTreeData: setTreeData,
    mode: mode,
    searchQuery: searchString,
    searchFocusOffset: searchFocusIndex
  })), /*#__PURE__*/_react["default"].createElement(DeviceViewWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.RootRoutes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("DeviceListPlantTwin") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(_DeviceListScreenPlantTwin.DeviceListScreenPlantTwin, {
          searchString: searchString,
          setNumDevicesMatched: setNumDevicesMatched
        });
      }
    })
  }))));
});